import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Header from "../../components/Header";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:8080";

const HelpPage = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [importance, setImportance] = useState("normal");
  const [attachment, setAttachment] = useState(null);
  const [ccEmails, setCcEmails] = useState("");
  const [userInfo, setUserInfo] = useState({ name: "", email: "" });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const res = await fetch(`${BASE_URL}/auth/me`, {
          credentials: "include",
        });
        const data = await res.json();
        if (data?.email) {
          setUserInfo({
            name: data.name ?? "Unknown User",
            email: data.email,
          });
        }
      } catch (err) {
        console.error("Failed to fetch profile info for help form");
      }
    };

    fetchUserInfo();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("subject", subject);
      formData.append("message", message);
      formData.append("importance", importance);
      formData.append("cc_emails", ccEmails);
      if (attachment) formData.append("attachment", attachment);

      const res = await fetch(`${BASE_URL}/api/tickets`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      if (res.ok) {
        setSuccess(true);
        setSubject("");
        setMessage("");
        setImportance("normal");
        setAttachment(null);
        setCcEmails("");
      } else {
        throw new Error("Submission failed");
      }
    } catch (err) {
      console.error("Error submitting ticket:", err);
      setSuccess(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box m="20px">
      <Header title="Need Help?" subtitle="Submit a support request" />
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Box display="flex" flexDirection="column" gap={2} maxWidth={600}>
          <TextField label="Name" value={userInfo.name} InputProps={{ readOnly: true }} />
          <TextField label="Email" value={userInfo.email} InputProps={{ readOnly: true }} />
          <TextField
            label="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            rows={6}
            required
          />
          <TextField
            label="CC (optional, comma-separated)"
            value={ccEmails}
            onChange={(e) => setCcEmails(e.target.value)}
            placeholder="e.g. alex@company.com, jordan@company.com"
          />
          <Box>
            <InputLabel>Importance</InputLabel>
            <Select
              value={importance}
              onChange={(e) => setImportance(e.target.value)}
              fullWidth
            >
              <MenuItem value="low">Low</MenuItem>
              <MenuItem value="normal">Normal</MenuItem>
              <MenuItem value="high">High</MenuItem>
            </Select>
          </Box>
          <Box>
            <InputLabel>Attachment (optional)</InputLabel>
            <input
              type="file"
              onChange={(e) => setAttachment(e.target.files[0])}
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            />
          </Box>
          <Button type="submit" variant="contained" disabled={submitting}>
            {submitting ? "Submitting..." : "Submit Ticket"}
          </Button>

          {/* ✅ Inline confirmation or error */}
          {success === true && (
            <Typography color="green">
              Ticket successfully created. Our support team will review the ticket and a team member will contact you shortly.
            </Typography>
          )}
          {success === false && (
            <Typography color="red">Submission failed.</Typography>
          )}
        </Box>
      </form>
    </Box>
  );
};

export default HelpPage;